import React from "react";
import { Button, Container } from "react-bootstrap";
import { useScroll } from "../../../../context/scroll-context";

const HeroBanner = ({ title, backgroundImage }) => {
  const { scrollToSection, contactform } = useScroll();
  const handleScrollAndClose = (refName) => {
    scrollToSection(refName);
  };
  return (
    <section
      className="products hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container fluid>
        <div className="content-block mb-3">
          <h2 className="text-white mb-3 ft-wt-700 mb-lg-5 big-title">
            {title}
          </h2>
          <div>
            <Button className="text-uppercase" variant="secondary">
              <h5
                className="mb-0 text-primary"
                onClick={() => handleScrollAndClose(contactform)}
              >
                Request for a demo
              </h5>
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HeroBanner;
